import { call } from "@saas/api-client";
import { Alert, Button, Card, ErrorAlert, useCommand } from "@saas/ui";
import { useState } from "react";
import { api } from "./api";

/** Pushes the database state to the identity provider again, e.g. after restoring a backup (docs/runbook.md). */
export function ResyncIdentityProviderCard() {
  const command = useCommand();
  const [done, setDone] = useState(false);

  const resync = async () => {
    setDone(false);
    if (await command.run(() => call(api.POST("/api/identity-provider/resync")))) setDone(true);
  };

  return (
    <Card
      title="Identity provider"
      description="The database decides who may sign in. Resync pushes every administrator and every tenant member to the identity provider again, for example after restoring a backup."
    >
      <ErrorAlert error={command.error} />
      {done && <Alert tone="success">Resync scheduled. The jobs run in the background; failures show up above.</Alert>}
      <div>
        <Button onClick={resync} disabled={command.pending}>
          {command.pending ? "Scheduling…" : "Resync identity provider"}
        </Button>
      </div>
    </Card>
  );
}
